import React from 'react';
import {shallowEqual, useSelector} from "react-redux";

function Geoportail1115(props){

    const geoportail1115 = useSelector(state => state.geoportail1115ApiReducer.geoportail1115 , shallowEqual)

    const google = window.google;
    const map = props.map;
    let geoportail1115Data;


    function geoportail1115Map(map) {
        if(map != null){
            if(geoportail1115){
                geoportail1115Data = new google.maps.ImageMapType({
                    maxZoom: 19,
                    minZoom: 0,
                    name: "Geoportail1115",
                    tileSize: new google.maps.Size(256, 256),
                    getTileUrl: function (coordinates, zoom) {
                        // Pour DEV
                        //return 'https://wxs.ign.fr/an7nvfzojv5wa96dsga5nk8w/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS2014&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/jpeg';

                        // Pour PROD
                        return 'https://wxs.ign.fr/0skh99buqiuj9k125e4d5q9h/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS2014&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/jpeg';
                    }
                });
                map.overlayMapTypes.insertAt(0, geoportail1115Data);
            }else{
                map.overlayMapTypes.forEach(function (object, index) {
                    map.overlayMapTypes.removeAt(index, geoportail1115Data);
                });
            }
        }
    }


    return(
        <div>
            {geoportail1115Map(map)}
        </div>
    )
}
export default React.memo(Geoportail1115);